import './ytCard.scss'

export default {
    name: 'YtCard',

    props: {
        // 标题
        title: {
            type: String,
            default: ''
        },

        // 标题
        dzTitle: {
            type: String,
            default: ''
        },

        // 定制tab
        dzTab: {
            type: Array,
            default: () => []
        },

        // 定制tab active
        dzTabIndex: {
            type: Number,
            default: 1
        },

        // 标题大小 'normal' | 'small', 分别为 `18px` 和 `14px`
        size: {
            type: String,
            default: 'normal'
        },

        // 描述
        desc: {
            type: String,
            default: ''
        },

        // 【更多>>】路径
        path: {
            type: String,
            default: ''
        },

        // 是否显示标题底部边框
        noBorder: {
            type: Boolean,
            default: false
        },
        noHeader:{
            type: Boolean,
            default: true
        },
        // 默认 el-card-body 不带 20px 内边距
        noBody: {
            type: Boolean,
            default: true
        },

        // el-card 高度
        height: Number
    },

    methods: {
        toPath() {
            this.$router.push({
                path: this.path
            })
        },
        titleCli(val) {
            console.log('.....cart tab cli', val)
            this.$emit('onTabChange', val)
        }
    },

    render() {
        const DescEl = (
            <div class='card-header_desc'>
                {
                    // slot 内容优先于 desc 属性
                    (this.desc && this.$slots.desc) && this.$slots.desc
                }

                {
                    // 只有 desc 属性
                    (this.desc && !this.$slots.desc) && <div class='desc'>{this.desc}</div>
                }

                {
                    // 只有 slot
                    (!this.desc && this.$slots.desc) && this.$slots.desc
                }

                {
                    this.path && (
                        <div class='desc-right_extra'>
                            <span class='more-btn' onClick={this.toPath}>更多>></span>
                        </div>
                    )
                }

                {
                    this.$slots.more && (
                        <div class='desc-right_extra'>{this.$slots.more}</div>
                    )
                }
            </div>
        )


        return (
            <div class={`yt-card ${(!this.$slots.default || this.noBody) ? 'noBody' : ''} ${this.noBorder ? 'noBorder' : ''}`}>
                <el-card style={this.height ? `height: ${this.height}px;` : ''}>
                    {
                        this.noHeader && (
                            <div slot='header' class='yt-card_header' >
                                <div class='card-header_title'>
                                    {
                                    this.title && (<div class={`title ${this.size}`}>{this.title}</div>)
                                    }
                                    {
                                        this.dzTab && this.dzTab.length > 0 && (
                                            <div class='dz-tab'>
                                                {
                                                    this.dzTab.length > 0 && this.dzTab.map((item, i) => (
                                                        <div class={`item ${this.dzTabIndex === item.value ? 'active' : ''}`} onClick={() => this.titleCli(item.value)}>{ item.name }</div>
                                                    ))
                                                }
                                            </div>
                                        )
                                    }
                                    {
                                        this.dzTitle && (
                                            <div class='dz-title'>{this.dzTitle}</div>
                                        )
                                    }
                                    {
                                        this.$slots.extra && (
                                            <div class='title-right_extra'>{this.$slots.extra}</div>
                                        )
                                    }
                                </div>
                                {(this.desc || this.path || this.$slots.desc || this.$slots.more) && DescEl}
                            </div>
                        )
                    }

                    <div class='yt-card_body'>
                        {this.$slots.default}
                    </div>
                </el-card>
            </div>
        )
    }
}
